// @flow
import React from 'react'
import styled from 'styled-components';

const Image = (props) => {
    const {source} = props

    return (
        <ImageContainer 
            src={source}
        />
    )
}

// const ImageContainer = styled.div`
//     background: url(${props => props.source });
//     width: 500px;
//     height: 500px;
// `

const ImageContainer = styled.img`
    width: 100%;
    height: auto;
`


export default Image



// WEBPACK FOOTER //
// ./client/components/Image/Image.js